import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup , Validators } from '@angular/forms';
import {BasicService} from 'src/service/basic.service';
import { Router,ActivatedRoute } from '@angular/router';
import { AuthService } from 'src/service/auth';
import { BRAND_ASSETS } from '../constants/branding';
declare var require: any;
const Swal = require('sweetalert2');
@Component({
  selector: 'app-forgotpassword',
  templateUrl: './forgotpassword.component.html',
  styleUrls: ['./forgotpassword.component.scss']
})
export class ForgotpasswordComponent implements OnInit {
  brand = BRAND_ASSETS;

  loginForm:FormGroup;
  errorMsg:any = null;
  successMsg:any = null;
  success:any = null;
  showprogress = false;
  showPassword: boolean = false;
  token=''
  constructor(private authService: AuthService,private activatedRoute:ActivatedRoute,private router: Router,private fb:FormBuilder,private basicService:BasicService) { 
    this.loginForm= fb.group({
      password:[null,[Validators.required,this.basicService.isEmpty]]
    })    
    activatedRoute.params.subscribe(params=>{
      this.token=params['token'];
    });
  }

  ngOnInit(): void {
  }
  togglePasswordVisibility(): void {
    this.showPassword = !this.showPassword;
  }
  onSubmit = () =>{
    if (this.loginForm.valid) {
      let data={
        newPassword:this.loginForm.controls["password"].value,
        token:this.token
      }
      this.basicService.showprogress=true;
      this.authService.resetPassword(data).toPromise().then((response: any) => {
        this.basicService.showprogress=false;
        if(response.status === "success"){
          this.basicService.user_data=response.user_data
          this.basicService.user_data.password=this.loginForm.controls["password"].value
          this.basicService.setItem("user_data",this.basicService.user_data);
          Swal.fire('Success!', 'Password reset successfully', 'success').then((result:any) => {
            this.router.navigate(['/allworkspace']);
          })
        } else {
          Swal.fire({
            icon: 'Error',
            title: 'Error',
            text: response.message,
            confirmButtonColor: '##0d6efd',
            showCancelButton: false,
            allowOutsideClick: true,
            confirmButtonText: 'Ok'
          }).then((result:any) => {
          });
        }
      }); 
        
    }else{
      for (const x in this.loginForm.controls) {
        if (this.loginForm.controls.hasOwnProperty(x)) {
            this.loginForm.controls[x].markAsTouched()
        }
      }
    }
  }
}



